export default __webpack_public_path__ + "static/media/Anto virgule 3.1 (1).477dd2dd.mp3";